/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Hibbeler
 * Date: 23.02.2016
 */
import { ActionTypesCommon, AppContext, AsyncState, ReduceStore } from 'plugin/liferay-widgets-react-web';


export default class PageSelectedStore extends ReduceStore {

    constructor() {
        super(AppContext.getDispatcher());

    }

    getInitialState() {
        return { selected: null };
    }

    getRemoteData(name) {
        return this.getPageSelected();
    }

    getPageSelected() {
        return this.getState().selected;
    }

    getRemotePageSelected(state) {
        const remoteDataStores = AppContext.getStores().filter(s => s.getRemoteData && s !== this);
        this.getDispatcher().waitFor(remoteDataStores.map(s => s.getDispatchToken()));
        const selected = remoteDataStores.reduce((a, store) => {
            const s = store.getRemoteData(ActionTypesCommon.PAGE_SELECTED);
            return s ? a.concat(s) : a;
        }, []);
        state = {
            selected
        };
        return state;
    }

    reduce(state, action) {

        switch (action.type) {

            case ActionTypesCommon.PAGE_SELECTED:
                //this implementation is multi value ready
                state = this.getRemotePageSelected(state);
                break;

            case ActionTypesCommon.DATA_ASYNC:
                if (action.meta.name == ActionTypesCommon.PAGE_SELECTED) {
                    switch (action.meta.asyncState) {
                        case AsyncState.SUCCESS:
                            state = this.getRemotePageSelected(state);
                    }
                }
            //no default

        }

        return state;
    }


}



// WEBPACK FOOTER //
// ./js/stores/PageSelectedStore.js